import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { formattingDigitCurrency } from 'utils';
import { useTranslation } from 'react-i18next';
import Discount from '../Discount/Discount';

const useStyles = makeStyles((theme) => ({
  root: {
    //backgroundColor: 'rgba(171, 171, 171, 0.1)',
    padding: '0.2rem 0'
  },
  total: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& h6': {
      fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
      fontWeight: 600,
    },
	marginBottom: 0,
	paddingBottom: 0
  },
  label: {
	fontSize: '1.1rem',
    fontWeight: 600,
  },
  slabel: {
	fontSize: '0.9rem'
  },
  bold: {
    fontWeight: 600,
  },
}));

const TotalLow = ({ amount, discount, currency, styles, label }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { countryCode, labelCode } = currency || {};
  const { bold } = styles || {};
  
  const formattingAmount = formattingDigitCurrency(
    amount,
    countryCode,
    labelCode,
  );
  const hasDiscountOrOffered = discount?.global+discount?.products;
  const formatedDiscountAmount = formattingDigitCurrency(
    hasDiscountOrOffered,
    countryCode,
    labelCode,
  );
  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} className={classes.total}>
        <Typography
          display="inline"
          data-testid="label"
          className={`${classes.label}`}
        >
          {label}
        </Typography>
        <Typography
          display="inline"
          className={`${classes.label}`}
          data-testid="amount"
        >
          {formattingAmount}
        </Typography>
      </Grid>
	  {hasDiscountOrOffered > 0?
		<Grid item xs={12} className={classes.total}>
			<Typography
			display="inline"
			data-testid="label"
			className={`${classes.slabel}`}
			>
			{t("totalReducedBy")}
			<b>{formatedDiscountAmount}</b>
			{t("ofDiscountAndOffered")}
			</Typography>
		</Grid>
		:null}
    </Grid>
  );
};

TotalLow.propTypes = {
  totals: PropTypes.shape({
    amount: PropTypes.number,
  }).isRequired,
  currency: PropTypes.shape({
    countryCode: PropTypes.string,
    labelCode: PropTypes.string,
    symbol: PropTypes.string,
  }).isRequired,
  label: PropTypes.string,
  styles: PropTypes.object,
};

TotalLow.defaultProps = {
  totals: {
    amount: 0,
  },
  currency: {
    countryCode: 'fr-FR',
    labelCode: 'EUR',
    symbol: '€',
  },
  label: 'totalToPay',
  styles: {
    bold: false,
  },
};
export default TotalLow;
